import React from "react";
import Navbar from "../components/Navbar";
import HeroVisual from "../components/HeroVisual";
import CaseStudies from "../components/CaseStudies";
import PersonalProjects from "../components/PersonalProjects";
import HowIWork from "../components/HowIWork";
import About from "../components/About";
import HiringCTA from "../components/HiringCTA";

const Home = () => {
  return (
    <div className="min-h-screen bg-white dark:bg-neutral-950 text-neutral-900 dark:text-neutral-50 antialiased selection:bg-neutral-900 selection:text-white dark:selection:bg-white dark:selection:text-neutral-900 transition-colors duration-300">
      <Navbar />
      <main>
        <HeroVisual />
        <CaseStudies />
        <PersonalProjects />
        <HowIWork />
        <About />
        <HiringCTA />
      </main>
    </div>
  );
};

export default Home;
